<div class="list">
  <ng-container
    *ngIf="
      globalService.footer.show_social_media &&
      (globalService.social.facebook ||
        globalService.social.twitter ||
        globalService.social.pinterest ||
        globalService.social.instagram ||
        globalService.social.youtube ||
        globalService.social.tiktok)
    "
  >
    <div class="list__content container-social">
      <app-social-icons
        [facebook]="globalService.social.facebook"
        [twitter]="globalService.social.twitter"
        [pinterest]="globalService.social.pinterest"
        [instagram]="globalService.social.instagram"
        [youtube]="globalService.social.youtube"
        [tiktok]="globalService.social.tiktok"
        [forceSize]="'xs'"
      >
      </app-social-icons>
    </div>
  </ng-container>

  <div class="creator" *ngIf="globalService.footer.show_logo_tn">
    <div class="list__header">
      <p class="creator_title">Creado con</p>
    </div>
    <div class="list__content">
      <a
        class="creator_logo"
        href="https://tiendanegocio.com"
        target="_blank"
      >
        <app-logo-tn class="logo-tn"></app-logo-tn>
      </a>
    </div>
  </div>
</div>
